export const FETCH_WORKSPACES = 'FETCH_WORKSPACES';
export const FETCH_WORKSPACES_SUCCESS = 'FETCH_WORKSPACES_SUCCESS';
export const FETCH_WORKSPACES_FAIL = 'FETCH_WORKSPACES_FAIL';

/* How many runs of each sandbox are queued or running, read from the runs. A convenience: it cannot fail the list of sandboxes. */
export const FETCH_ACTIVE_RUNS_SUCCESS = 'FETCH_ACTIVE_RUNS_SUCCESS';

export const CREATE_WORKSPACE = 'CREATE_WORKSPACE';
export const REFRESH_WORKSPACE = 'REFRESH_WORKSPACE';
export const RESET_WORKSPACE = 'RESET_WORKSPACE';
export const DELETE_WORKSPACE = 'DELETE_WORKSPACE';

/* The outcome of any of the four above, which are all the same shape: a call on one workspace that is done or refused. */
export const WORKSPACE_ACTION_SUCCESS = 'WORKSPACE_ACTION_SUCCESS';
export const WORKSPACE_ACTION_FAIL = 'WORKSPACE_ACTION_FAIL';
